import React, { useRef, useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import api from "@/services/api";
import toast from "react-hot-toast";

interface UploadCsvProps {
    apiUrl: string;
    title?: string;
    sampleUrl?: string;
    onSuccess?: () => void;
}

const UploadCsv: React.FC<UploadCsvProps> = ({
    apiUrl,
    title = "Import CSV",
    // sampleUrl = "/sample_download.csv",
    onSuccess
}) => {

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState<File | null>(null);

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {

        const selectedFile = event.target.files?.[0];

        if (!selectedFile) return;

        if (!selectedFile.name.endsWith(".csv")) {
            toast.error("Only CSV files allowed");
            return;
        }

        setFile(selectedFile);
    };

    const handleUpload = async () => {

        if (!file) {
            toast.error("Please select CSV file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {

            await api.post(apiUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            toast.success("CSV uploaded successfully");

            onSuccess?.();

            setFile(null);
            setOpen(false);

        } catch (error) {
            console.error(error);
            toast.error("Upload failed");
        }
    };
    const sampleUrl = "/sample_download.csv"
    const handleDownloadSample = () => {
        const link = document.createElement("a");
        link.href = sampleUrl
        link.download = "sample_data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <>
            {/* Button to open popup */}
            <Button
                variant="contained"
                startIcon={<UploadFileIcon />}
                sx={{
                    backgroundColor: "#5BC0BE",
                    "&:hover": { backgroundColor: "#49a9a7" },
                }}
                onClick={() => setOpen(true)}
            >
                Upload CSV
            </Button>

            {/* Popup */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>

                <DialogTitle>
                    {title}
                </DialogTitle>

                <DialogContent>

                    <Typography sx={{ mb: 2 }}>
                        Upload CSV file (.csv)
                    </Typography>

                    <Box display="flex" alignItems="center" gap={2}>

                        <input
                            hidden
                            type="file"
                            accept=".csv"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />

                        <Button
                            variant="outlined"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            Upload File
                        </Button>
                        <Button
                            variant="text"
                            onClick={handleDownloadSample}
                            sx={{ textTransform: "none" }}
                        >
                            Download Sample
                        </Button>


                    </Box>

                    {file && (
                        <Typography sx={{ mt: 2 }}>
                            Selected: {file.name}
                        </Typography>
                    )}

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setOpen(false)}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleUpload}
                        sx={{
                            backgroundColor: "#5BC0BE",
                            "&:hover": { backgroundColor: "#49a9a7" }
                        }}
                    >
                        Upload
                    </Button>


                </DialogActions>

            </Dialog>
        </>
    );
};

export default UploadCsv;